import React from "react";
import product from "../assets/product.png";
import heart from "../assets/heart.png";
import { HeartFilled, HeartOutlined, PlusOutlined } from "@ant-design/icons";
import { toggleFavorite } from "../redux/ecommerce/favoriteSlice";
import { useDispatch, useSelector } from "react-redux";
import { useState } from 'react';
import { message } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { addCart } from "../redux/ecommerce/cartSlice";
import { Link } from "react-router-dom";
import OrderEmpty from "../assets/myOrders/OrderEmpty.png";

const Product2 = ({ id, color_id, image, name, price, count, favorite }) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isFavorite, setIsFavorite] = useState(false);

  const { cart, status, error } = useSelector((state) => state.cart);

  const handleAddToCart = async (e) => {
    e.preventDefault();

    const payload = {
      eco_products_id: id,
      count: count,
      color_id: color_id,
    };

    try {
      await dispatch(addCart(payload))
        .unwrap()
        .then(() => {
          message.success("Adding product to cart successful!");
          navigate("/cart");
        });
    } catch (error) {
      console.error("Error adding to cart:", error);
      message.error("Failed to add to cart. Please try again.");
    }
  };


  const handleToggleFavorite = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const newStatus = favorite === "yes" ? "no" : "yes";

    try {
      await dispatch(
        toggleFavorite({
          eco_products_id: id,
          status: newStatus,
        })
      ).unwrap();
      message.success(favorite ? "تمت الإزالة من المفضلة" : "تمت الإضافة للمفضلة");
    } catch (error) {
      console.error("Error toggle favorite:", error);
      message.error("حدث خطأ أثناء تعديل المفضلة.");
    }
  };

  return (
    <div className="bg-[#172e57] rounded-3xl px-7 pt-4 pb-7">
      <div className="relative">
        <img
          src={image}
          className="rounded-3xl w-[250px] h-[220px] mx-auto"
          onError={(e) => {
            e.target.src = OrderEmpty;
          }} />
        <div
          onClick={handleToggleFavorite}
          className="bg-[#FCFBFA] w-[40px] h-[40px] mx-auto flex items-center justify-center rounded-full absolute top-5 right-8 cursor-pointer hover:bg-gray-100 transition text-[#fe6625]"
        >
          {favorite === "no" ? (
            <HeartOutlined className="text-xl" />
          ) : (
            <img src={heart} className="w-[19px]" alt="favorite" />
          )}
        </div>
      </div>
      <div className="flex items-center justify-between px-3 mt-4">
        <Link to={`/productview/${id}`}>
          <p className="text-[#F3F5F7]">{name}</p>
          <p className="text-[#DDE5ED] font-semibold text-xl">{price} {t("SR")}</p>
        </Link>
        <button onClick={(e) => handleAddToCart(e)} className="bg-[#FE9B71] text-white flex items-center px-7 py-2 rounded-full font-semibold">
          Add <PlusOutlined className="ml-4" />
        </button>
      </div>
    </div>
  );
};

export default Product2;
